import * as React from 'react';
import {SessionContainer} from '../session';
import {StubWebSocketClient} from './stub-web-socket-client';

export interface ITryOutProps {
  userId: string;
  webSocketCommand?: (type: string, payload: any) => void;
  webSocketConnect?: () => void;
  webSocketDisconnect?: () => void;
}

export class TryOut extends React.Component<ITryOutProps, any> {
  private socket: StubWebSocketClient;

  constructor(props: ITryOutProps) {
    super(props);

    const {
      webSocketConnect,
      webSocketCommand,
      webSocketDisconnect,
    } = this.props;

    this.socket = new StubWebSocketClient(
      webSocketConnect,
      webSocketCommand,
      webSocketDisconnect,
    );
  }

  public componentWillUnmount(): void {
    this.socket.close();
  }

  public render(): React.ReactElement<any> {
    // @TODO:
    // - replace SessionContainer with small sub-components of the session
    // - remove property 'tryOutMode' from session component
    return (
      <SessionContainer
        tryOutMode
        socket={this.socket}
        userId={this.props.userId} />
    );
  }
}
